<mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Scheduling Information</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>Order is currently {{ scheduleOrder.status }}</p>
      <p>Order will change status to {{ calculateNextScheduleOrderStatus(scheduleOrder) }}</p>
    </mat-card-content>
  </mat-card>